import(/* webpackMode: "eager" */ "/usr/src/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["EnvVariablesClientProvider"] */ "/usr/src/app/src/context/EnvClientContext/EnvVariablesClientContext.tsx");
